import { CreditOption } from "../components/credit_quantity_picker";

interface CreditWidthSavingPercent extends CreditOption {
  savingPercent?: number;
}

export function calculateCreditsSavingPercent(
  credits: CreditOption[]
): CreditWidthSavingPercent[] {
  if (!credits.length) {
    return [];
  }

  const sortedOptions = credits.sort((a, b) => {
    return a.numberOfCredits - b.numberOfCredits;
  });

  const firstPackage = sortedOptions[0];
  const firstUnitPrice = firstPackage.price / firstPackage.numberOfCredits;

  const creditsWithSavingPercent = sortedOptions.map((c) => {
    const unitPrice = c.price / c.numberOfCredits;
    const creditPackage: CreditWidthSavingPercent = { ...c };
    if (unitPrice < firstUnitPrice) {
      const savingPercent = Math.round(
        ((firstUnitPrice - unitPrice) / firstUnitPrice) * 100
      );
      creditPackage.savingPercent = savingPercent;
    }
    return creditPackage;
  });

  return creditsWithSavingPercent;
}
